import { render, staticRenderFns } from "./atribuirTurma.vue?vue&type=template&id=bd533a6a&scoped=true&"
import script from "./atribuirTurma.vue?vue&type=script&lang=js&"
export * from "./atribuirTurma.vue?vue&type=script&lang=js&"
import style0 from "./atribuirTurma.vue?vue&type=style&index=0&id=bd533a6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd533a6a",
  null
  
)

export default component.exports